<template>
    <div v-if="!loading" class="card">
        <div class="card-body">
            <doughnut-chart
            :chartdata="chartdata"
            :options="options"/>
        </div>
    </div>
</template>

<script>
import DoughnutChart from '../../shared/charts/DoughnutChart.vue'

export default {
  name: 'AcceptanceRatioChart',
  components: { DoughnutChart },
  data: () => ({
    loading: true,
    acceptedCount: null,
    decidedCount: null,
    options: null,
  }),

  computed: {
      chartdata: function() {
          return {
            datasets: [{
                data: [this.acceptedCount, this.decidedCount - this.acceptedCount],
                backgroundColor: ['#28a745', '#ee3538']
            }],

            // These labels appear in the legend and in the tooltips when hovering different arcs
            labels: [
                'Accepted',
                'Rejected'
            ]
        };
      },
  },

  mounted () {
      this.loadAcceptanceRatio();
  },

  methods: {
    loadAcceptanceRatio() {
      this.loading = true;
      var self = this;
      axios
        .get("api/stats/submissions/count/decided", {
            params: {
                timescale: self.timescale
            }
        })
        .then(function(response) {
            self.decidedCount = response.data;
            if (self.decidedCount > 0)
            {
                axios
                .get("api/stats/submissions/count/accepted", {
                    params: {
                        timescale: self.timescale
                    }
                })
                .then(function(response) {
                    self.loading = false;
                    self.acceptedCount = response.data;
                })
                .catch(function(error) {
                    console.log(error);
                    self.error = true;
                });
            }
        })
        .catch(function(error) {
          console.log(error);
          self.error = true;
        });
    }
  }
}
</script>
